<template>
  <div class="registration">

        <div class="container">
          <h1 class="title is-size-1">You have Registered! </h1>   
          <h3>Thank you for signing up! You are almost ready to start sharing your stories.</h3>
          <h3>Please open the email we just sent and confirm your email address.</h3>    
        </div>


  </div>
</template>

<script>



export default {
  name: 'RegistrationConfirmation',
  components: {
     
  },
 data() {
    return {
      

    };
  },


}
</script>
<style lang="scss" scoped>

 
</style>